{
	"content": {
		"declarationDetailsSection": {
			"title": "Στοιχεία δήλωσης",
			"description": "Για τη δημιουργία της δήλωσης απαιτείται το όνομα πελάτη, η διεύθυνση και η χώρα του κατόχου της δήλωσης. Οι πληροφορίες δεν μπορούν να αλλάξουν μετά.",
			"customerLabel": "Λογαριασμός πελάτη"
		},
		"provideDeclarationsDetailsSection": {
			"title": "Δώστε τα στοιχεία της δήλωσης",
			"alertDescription": "Οι πληροφορίες που παρέχετε θα καταγράφονται μόνιμα στη δήλωση και δεν μπορούν να τροποποιηθούν στη συνέχεια.",
			"projectLabel": "Αναφορά έργου",
			"companyNameLabel": "Επωνυμία εταιρείας",
			"streetLabel": "Δρόμος",
			"zipCodeLabel": "Τ.Κ",
			"cityLabel": "Πόλη",
			"countryLabel": "Χώρα"
		}
	},
	"summary": {
		"title": "Περίληψη",
		"declarationTypeTitle": "Τύπος δήλωσης",
		"customerProjectTitle": "Έργο πελάτη",
		"internalProjectOrProductTitle": "Εσωτερικό έργο / προϊόν",
		"projectReferenceTitle": "Αναφορά έργου",
		"materialHeaderTitle": "Υλικό",
		"quantityHeaderTitle": "Ποσότητα ({{unit}})",
		"totalTransferableCarbonReductionsTitle": "Κατανεμόμενες μειώσεις άνθρακα ({{unit}})",
		"nonTransferableCarbonReductionTitle": "Μη κατανεμόμενη μείωση άνθρακα ({{unit}})"
	},
	"errorMessages": {
		"projectRequired": "Απαιτείται αναφορά στο έργο",
		"companyNameRequired": "Απαιτείται το όνομα της εταιρείας",
		"streetRequired": "Απαιτείται οδός",
		"zipCodeRequired": "Απαιτείται ταχυδρομικός κώδικας",
		"cityRequired": "Η πόλη απαιτείται",
		"countryRequired": "Απαιτείται χώρα",
		"customerRequired": "Απαιτείται πελάτης"
	},
	"reviewDeclarationDetailsModal": {
		"title": "Ελέγξτε τη σύνοψη της δήλωσης",
		"description": "Ελέγξτε τα δεδομένα που έχετε εισαγάγει για τυχόν λάθη.",
		"alertDescription": "Οι πληροφορίες που έχετε δώσει θα καταγράφονται μόνιμα στη δήλωση και δεν μπορούν να τροποποιηθούν στη συνέχεια.",
		"typeSectionTitle": "1. Τύπος",
		"declarationTypeLabel": "Τύπος δήλωσης",
		"customerProjectTitle": "Έργο πελάτη",
		"internalProjectOrProductTitle": "Εσωτερικό έργο / προϊόν",
		"projectReferenceLabel": "Αναφορά έργου",
		"materialSectionTitle": "2. Υλικό",
		"materialHeaderTitle": "Υλικό",
		"quantityHeaderTitle": "Ποσότητα ({{unit}})",
		"totalCarbonReductionsLabel": "Συνολικές μειώσεις άνθρακα ({{unit}})",
		"declarationSectionTitle": "3. Δήλωση",
		"companyNameLabel": "Επωνυμία εταιρείας",
		"streetLabel": "Δρόμος",
		"zipCodeLabel": "Τ.Κ",
		"cityLabel": "Πόλη",
		"countryLabel": "Χώρα",
		"backTitle": "Πίσω",
		"submitTitle": "Ναι, όλα είναι σωστά"
	},
	"submitTitle": "Δημιουργία δήλωσης",
	"backTitle": "Πίσω"
}
